"use strict";
var $ = require("jquery");
var Clipboard = require("clipboard");
var dateTimeUtils_1 = require("../utils/dateTimeUtils");
var stringUtils_1 = require("../../app/utils/stringUtils");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var richContentUtils_1 = require("../utils/richContentUtils");
var imageZoomUtils_1 = require("../../app/utils/imageZoomUtils");
var CommentUtils = (function () {
    function CommentUtils() {
    }
    CommentUtils.getComment = function (commentId) {
        return $("#" + commentId).siblings(".comment");
    };
    CommentUtils.toggleAsPinned = function (btn, commentId, isPinned) {
        var _this = this;
        var $btn = $(btn);
        if ($btn.attr('disabled'))
            return;
        $btn.attr('disabled', 'disabled');
        var id = parseInt(this.getComment(commentId).attr('data-id'));
        ajaxUtils_1.AjaxUtils.get('comment/toggleAsPinned', { id: id, isPinned: isPinned })
            .done(function (result) {
            if (result.isSuccessful) {
                alert(isPinned ? 'Комментарий откреплен.' : 'Комментарий закреплен.');
                _this.reloadComments();
            }
            else {
                alert(result.messages[0]);
            }
        })
            .always(function () {
            $btn.removeAttr('disabled');
        });
    };
    CommentUtils.toggleHide = function (btn, commentId, hide) {
        var _this = this;
        var $btn = $(btn);
        if ($btn.attr('disabled'))
            return;
        var messageText = hide ? "Вы действительно хотите скрыть комментарий под спойлер?<br/>Действие является необратимым." : "Вы уверены, что хотите отменить скрытие комментария?";
        app.f7.modal({
            title: "Скрытие комментария",
            text: messageText,
            buttons: [
                {
                    text: "Ok",
                    onClick: function () {
                        $btn.attr('disabled', 'disabled');
                        var $comment = _this.getComment(commentId);
                        var id = parseInt($comment.attr('data-id'));
                        ajaxUtils_1.AjaxUtils.post('comment/hide', { id: id, isHiddenByAuthor: hide })
                            .done(function (result) {
                            if (result.isSuccessful) {
                                var $html = $(result.data.html);
                                $comment.replaceWith($html);
                                dateTimeUtils_1.default.displayTime($html);
                                imageZoomUtils_1.default.init($html);
                            }
                            else {
                                alert(result.messages[0]);
                            }
                        })
                            .always(function () {
                            $btn.removeAttr('disabled');
                        });
                    }
                },
                {
                    text: "Отмена",
                }
            ]
        });
    };
    CommentUtils.showReplyForm = function ($comment) {
        var _this = this;
        if (!window["app"].isAuthenticated) {
            $comment.find(".reply-placeholder").show();
            return;
        }
        ;
        if (this.onCancelEditing) {
            this.onCancelEditing();
            this.onCancelEditing = null;
        }
        if (this.onCancelReply) {
            this.onCancelReply();
            this.onCancelReply = null;
        }
        var id = parseInt($comment.attr("data-id")), threadId = parseInt($comment.attr("data-thread")), level = parseInt($comment.attr("data-level")), isIgnored = $comment.attr("data-is-ignored") === "true";
        $("mobile-comment-form").appendTo($comment.find(".reply-placeholder"));
        var commendData = {
            id: null,
            parentId: id,
            threadId: threadId,
            level: level + 1,
            text: "",
            isIgnored: isIgnored,
            isPinned: false
        };
        var rootId = $comment.attr("data-root-id") || null;
        var rootType = $comment.attr("data-root-type") || null;
        var form = this.getForm(rootId, rootType);
        form.startCreating(commendData, function (data) {
            _this.restoreRootReply();
            var $html = $(data.html);
            $comment.siblings(".replies").append($html);
            dateTimeUtils_1.default.displayTime($html);
            $comment.removeClass("c-reply");
            if ($comment.hasClass("shifted")) {
                _this.unshiftComment($comment);
            }
            var $wrapper = $comment.parent();
            if (!$wrapper.hasClass("expanded-replies") &&
                !$wrapper.hasClass("collapsed-replies")) {
                $wrapper.addClass("expanded-replies");
                $wrapper.find(".replies-count").html("1");
            }
            imageZoomUtils_1.default.init($html);
        });
        $comment.addClass("c-reply");
        this.onCancelReply = function () {
            $comment.removeClass("c-reply");
            $(".comment.shifted").removeClass("shifted").removeAttr("style");
            form.cancel();
            _this.restoreRootReply();
        };
    };
    CommentUtils.edit = function (commentId, rootId, rootType) {
        var _this = this;
        if (rootId === void 0) { rootId = null; }
        if (rootType === void 0) { rootType = null; }
        if (this.onCancelEditing) {
            this.onCancelEditing();
            this.onCancelEditing = null;
        }
        if (this.onCancelReply) {
            this.onCancelReply();
            this.onCancelReply = null;
        }
        var $comment = this.getComment(commentId), id = parseInt($comment.attr("data-id")), isIgnored = $comment.attr("data-is-ignored") === "true", isPinned = $comment.attr("data-is-pinned") === "true";
        var $textContainer = $comment.find("article"), currentText = $comment.find("article").html(), originalText = $comment.find(".rich-content").html();
        originalText = richContentUtils_1.default.richTextToFroala(originalText);
        this.onCancelEditing = function () {
            _this.restoreRootReply();
            $textContainer.html(currentText);
            $comment.removeClass("c-editing")
                .addClass("c-view")
                .removeClass("shifted")
                .removeAttr("style");
            $(".comment.shifted").removeClass("shifted").removeAttr("style");
        };
        $textContainer.empty();
        $("mobile-comment-form").appendTo($textContainer);
        var commendData = {
            id: id,
            text: originalText,
            isIgnored: isIgnored,
            isPinned: isPinned
        };
        function replaceCommentMarkup(html) {
            var $html = $(html);
            $comment.replaceWith($html);
            dateTimeUtils_1.default.displayTime($html);
            imageZoomUtils_1.default.init($html);
        }
        this.getForm(rootId, rootType).startEditing(commendData, function (data) {
            _this.restoreRootReply();
            replaceCommentMarkup(data.html);
        }, this.onCancelEditing, function (data) {
            _this.restoreRootReply();
            if (data.fullDelete) {
                var $wrapper = $comment.parent();
                var $replies = $wrapper.parent(".replies");
                if ($replies.find(".comment").length === 1) {
                    $replies.parent()
                        .removeClass("expanded-replies")
                        .removeClass("collapsed-replies");
                }
                $wrapper.remove();
            }
            else if (data.isReload) {
                CommentUtils.reloadComments();
            }
            else {
                replaceCommentMarkup(data.html);
            }
        });
        var level = parseInt($comment.attr("data-level"));
        $comment.removeClass("c-view").addClass("c-editing").css("margin-left", -10 * level - 10);
    };
    CommentUtils.cancel = function (commentId) {
        var $comment = this.getComment(commentId);
        var form = this.getForm(null, null);
        form.cancel();
        this.restoreRootReply();
        $comment.removeClass("c-reply");
    };
    CommentUtils.showHidden = function (commentId) {
        var $comment = this.getComment(commentId);
        var $toggle = $comment.find(".comment-hidden-toggle");
        var hiddenComment = $comment.find(".hidden-content");
        if ($toggle.data("commentVisible") && $toggle.data("commentVisible") === true) {
            $toggle.text("показать комментарий");
            hiddenComment.hide();
            $toggle.data("commentVisible", false);
        }
        else {
            $toggle.text("скрыть комментарий");
            hiddenComment.show();
            $toggle.data("commentVisible", true);
        }
    };
    CommentUtils.getForm = function (rootId, rootType) {
        var form = window["AppComponents"].MobileCommentForm;
        if (rootId && rootType) {
            form.rootId = rootId;
            form.rootType = rootType;
        }
        return form;
    };
    CommentUtils.restoreRootReply = function () {
        $("mobile-comment-form").appendTo(document.getElementById("root-reply-placeholder"));
    };
    CommentUtils.vote = function (btn, commentId, vote) {
        var $btn = $(btn);
        if ($btn.attr("disabled"))
            return;
        var toggleClass = "toggle", $comment = $("#" + commentId).siblings(".comment"), id = parseInt($comment.attr("data-id")), $rating = $comment.find(".comment-rating-count"), voteId = $rating.attr("data-vote-id");
        $btn.attr("disabled", "disabled");
        ajaxUtils_1.AjaxUtils.post("comment/vote", {
            voteId: voteId,
            targetId: id,
            isLiked: $btn.hasClass(toggleClass) ? null : vote === 1
        }).done(function (result) {
            if (result.isSuccessful) {
                $rating.html(result.data.rating);
                $rating.attr("data-vote-id", result.data.voteId);
                if ($btn.hasClass(toggleClass)) {
                    $btn.removeClass(toggleClass);
                }
                else {
                    $comment.find(".like, .dislike").removeClass(toggleClass);
                    $btn.addClass(toggleClass);
                }
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            $btn.removeAttr("disabled");
        });
    };
    CommentUtils.collapse = function (element) {
        var $el = $(element);
        var wrapper = $(element).parents(".comment-wrapper").get(0);
        $(wrapper).removeClass("expanded-replies").addClass("collapsed-replies");
        if ($el.is(".comments-hide-tree")) {
            return;
        }
        var comment = $(element).parents(".comment").get();
        this.unshiftComment($(comment));
    };
    CommentUtils.expand = function (element, parentId, rootId, rootType) {
        var _this = this;
        var $el = $(element);
        var state = $el.attr("data-state") || "none";
        if (state === "loading") {
            return;
        }
        if (state === "loaded") {
            $el.parent().removeClass("collapsed-replies").addClass("expanded-replies");
            return;
        }
        $el.attr("data-state", "loading");
        $el.find(".toggle-text").text("загрузка...");
        $el.find("i:first").removeClass("icon-plus-square-o").addClass("icon-spinner icon-spin-animate");
        var sorting = stringUtils_1.default.getParam("sorting");
        ajaxUtils_1.AjaxUtils.get("comment/loadThread", {
            parentId: parentId,
            rootId: rootId,
            rootType: rootType,
            lastViewTime: this.lastViewTime,
            sorting: sorting
        })
            .done(function (result) {
            if (!result.isSuccessful) {
                alert(result.messages[0]);
                $el.attr("data-state", "none");
                $el.find(".toggle-text").text("раскрыть ветку");
                $el.find("i:first").removeClass("icon-spinner icon-spin-animate").addClass("icon-plus-square-o");
                return;
            }
            $el.siblings(".replies").html(result.data.html);
            var $replies = $el.siblings(".replies");
            dateTimeUtils_1.default.displayTime($replies);
            richContentUtils_1.default.processHtml($replies);
            _this.initUtils();
            $el.find("i:first").removeClass("icon-spinner icon-spin-animate").addClass("icon-plus-square-o");
            $el.find(".toggle-text").text("раскрыть ветку");
            $el.parent().removeClass("collapsed-replies")
                .removeClass("is-new")
                .addClass("expanded-replies");
            imageZoomUtils_1.default.init($replies);
            $el.attr("data-state", "loaded");
        });
    };
    CommentUtils.loadMore = function (btn, soring, rootId, rootType) {
        var _this = this;
        var $btn = $(btn);
        if ($btn.attr("disabled"))
            return;
        var lastCommentId = $btn.attr("data-last-id");
        $btn.attr("disabled", "disabled");
        var $icon = $btn.find("i");
        $icon.addClass("icon-spin-animate");
        ajaxUtils_1.AjaxUtils.get("comment/loadMore", {
            soring: soring,
            lastCommentId: lastCommentId,
            rootId: rootId,
            rootType: rootType,
            lastViewTime: this.lastViewTime
        }).done(function (result) {
            if (result.isSuccessful) {
                $btn.attr("data-last-id", result.data.lastCommentId);
                var $html = $(result.data.html);
                $(".comments").append($html);
                $(".pagination-container").hide();
                $("#notLoadedComments")
                    .text(result.data.notLoaded +
                    " " +
                    stringUtils_1.default.pluralize(result.data.notLoaded, ["комментарий", "комментария", "комментариев"]));
                if (result.data.new > 0) {
                    $("#newNotLoadedComments").show();
                    $("#newNotLoadedComments")
                        .text("+" + " " + result.data.new + " " +
                        stringUtils_1.default.pluralize(result.data.new, ["новый", "новых", "новых"]));
                }
                else {
                    $btn.removeClass("is-new");
                    $("#newNotLoadedComments").hide();
                }
                dateTimeUtils_1.default.displayTime($html);
                richContentUtils_1.default.processHtml($html);
                _this.initUtils();
                if (result.data.more) {
                    $icon.removeClass("icon-spin-animate");
                }
                else {
                    $btn.hide();
                }
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            $btn.removeAttr("disabled");
        });
    };
    CommentUtils.scrollToParent = function (parentAnchor) {
        var $anchor = $(parentAnchor), $comment = $anchor.siblings(".comment"), $pageContent = $(".page-content");
        $comment.addClass("highlighted");
        setTimeout(function () {
            $comment.removeClass("highlighted");
        }, 500);
        var rect = $anchor[0].getBoundingClientRect();
        var offsetTop = rect.top + $pageContent[0].scrollTop;
        $pageContent.animate({ scrollTop: offsetTop }, 400);
    };
    CommentUtils.unshiftComment = function ($comment) {
        var isShifted = $comment.hasClass("shifted");
        var isReply = $comment.hasClass("c-reply");
        $(".comment.shifted").removeClass("shifted").removeAttr("style");
        $(".c-reply").removeClass("c-reply");
        if (isReply && $("#page-news-feed").length) {
            this.restoreRootReply();
        }
        else {
            if (!isShifted) {
                if ($comment.is(".without-reply-form")) {
                    $comment.addClass("shifted");
                }
                else {
                    if (!$comment.is(".noshift")) {
                        var level = parseInt($comment.attr("data-level"));
                        $comment.addClass("shifted").css("margin-left", -10 * level - 10);
                    }
                    this.showReplyForm($comment);
                }
            }
            else {
                this.restoreRootReply();
            }
        }
        var modal = $(".picker-modal.modal-in, .popover.modal-in")[0];
        if (modal) {
            app.f7.closeModal(modal);
        }
    };
    CommentUtils.initUtils = function () {
        var firstRun = this.clipboard === null;
        this.clipboard = new Clipboard(".comment-url", {
            text: function (el) { return location.origin + $(el).attr("data-clipboard"); }
        });
        if (firstRun) {
            this.clipboard.on("success", function (e) {
                alert("Ссылка на комментарий скопирована.");
            });
            this.clipboard.on("error", function (e) {
                var $el = $(e.trigger);
                var url = location.origin + $el.attr("data-clipboard");
                prompt("Ссылка на комментарий", url);
            });
        }
    };
    CommentUtils.init = function (lastViewTime) {
        var _this = this;
        this.lastViewTime = lastViewTime;
        $(document).ready(function () {
            _this.initUtils();
            var $highlighted = $(".highlighted");
            if ($highlighted[0]) {
                _this.scrollToNew($highlighted);
            }
        });
        $(document).off("touch.comments click.comments");
        $(document).on("touch.comments click.comments", ".comment", function (event) {
            var $target = $(event.target);
            var form = _this.getForm(null, null);
            if ($target.parents(".edit-reply")[0]
                || $target.parents(".comment-toggle")[0]
                || $target.parents(".modal")[0])
                return;
            if ($target.attr("data-show-comment")
                || $target.parents(".spoiler")[0]
                || $target.is(".spoiler"))
                return;
            if (!$target.parents("article")[0]
                && !$target.parents("header")[0]
                && !$target.is(".comment-reply-link")
                && !$target.hasClass("unshift-comment"))
                return;
            // при попытке перехода по ссылке используем только подтверждение перехода на страницу
            // ссылка в комментариях или ссылка на страницу автора
            var isUrl = $target.is('a') && $target.parent().parent(".comment-content").length
                || $target.parent().children().hasClass("comment-user-name");
            if (!isUrl && !$target.is('button') && form && form.isTextChange && !confirm("Комментарий не отправлен и не будет сохранён. Продолжить?")) {
                return;
            }
            setTimeout(function () {
                // если был переход по ссылке, то мы либо перешли, либо отменили его
                if (isUrl) {
                    return;
                }
                if (_this.onCancelEditing) {
                    _this.onCancelEditing();
                    _this.onCancelEditing = null;
                }
                if (_this.onCancelReply) {
                    _this.onCancelReply();
                    _this.onCancelReply = null;
                }
                else {
                    var $comment = $target.is(".comment") ? $target : $target.closest(".comment");
                    _this.unshiftComment($comment);
                }
            }, 0);
        });
    };
    CommentUtils.scrollToNew = function (el) {
        var $el = $(el);
        var $anchor, $toHighlight;
        if ($el.is(".comment")) {
            $toHighlight = $el;
            $el.parent()
                .parentsUntil(".comments", ".collapsed-replies")
                .removeClass("collapsed-replies")
                .addClass("expanded-replies");
            $anchor = $el.siblings(".anchor");
        }
        else if ($el.is(".load-more-comments")) {
            $toHighlight = $el;
            $anchor = $el;
        }
        else {
            $toHighlight = $el.find(".comment-toggle-expand");
            $anchor = $el.find(".anchor");
        }
        if (!$toHighlight.is(".highlighted")) {
            $toHighlight.addClass("highlighted");
            setTimeout(function () {
                $toHighlight.removeClass("highlighted");
            }, 500);
        }
        $(".page-content").animate({ scrollTop: $anchor.offset().top }, { duration: 400, queue: false });
    };
    CommentUtils.reloadComments = function () {
        window.location.reload();
    };
    CommentUtils.clipboard = null;
    return CommentUtils;
}());
if (!window["AppUtils"])
    window["AppUtils"] = {};
window["AppUtils"].Comment = CommentUtils;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CommentUtils;
//# sourceMappingURL=commentUtils.js.map